import { useAuthStore } from '@/features/auth/stores/auth.store';
import axios from 'axios';
import { getLocalStorage } from '../utilities/local-storage';

export const http = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

http.interceptors.request.use(async (cfg) => {
  const { accessToken } = getLocalStorage();
  if (!accessToken) return cfg;
  // biome-ignore lint/complexity/useLiteralKeys: <explanation>
  cfg.headers['Orion'] = `Rigel ${accessToken}`;
  cfg.headers.Authorization = `Bearer ${accessToken}`;

  return cfg;
});

http.interceptors.response.use(
  (response) => {
    switch (response.status) {
      default:
        return response;
    }
  },
  async (error) => {
    if (error.status === 499) {
      throw new Error(error.response?.data?.Message);
    }

    switch (error.response?.status) {
      case 401: {
        const newToken = await useAuthStore.getState().refreshAccessToken();
        if (newToken) {
          return http(error.config);
        }
        break;
      }

      default:
        break;
    }

    return Promise.reject(error);
  }
);
